<div [class]="'inline-flex items-center rounded-xl py-0.5 ' + color + ' ' + size + ' ' + additionalClasses" [ngClass]="{'w-full': truncate, 'cursor-pointer': copyable}" [matTooltip]="data" (click)="copyable ? copyText() : null">
  <div *ngIf="iconLeft" class="mx-1 shrink-0 mt-1">
    <mat-icon svgIcon="{{iconLeft}}"></mat-icon>
  </div>
  <span [ngClass]="{'truncate': truncate, 'text-xs': size === 'xs'}" class="px-1">{{data}}</span>
  <div *ngIf="iconRight" class="mx-1 shrink-0 mt-1">
    <mat-icon svgIcon="{{iconRight}}"></mat-icon>
  </div>
</div>
